module.exports = __webpack_public_path__ + "img/tu03.a215e7ce.png";